(function () {
  function closest(root, selector) {
    return root && root.closest ? root.closest(selector) : null;
  }

  function initSaleNav(scope) {
    scope.querySelectorAll('[data-emiah-sale-nav]').forEach(function (nav) {
      var toggle = nav.querySelector('[data-emiah-sale-nav-toggle]');
      var links = nav.querySelectorAll('[data-emiah-sale-nav-link]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          nav.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', nav.classList.contains('is-open') ? 'true' : 'false');
        });
      }
      links.forEach(function (link) {
        link.addEventListener('click', function () {
          nav.classList.remove('is-open');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }

  function initSaleModals(scope) {
    scope.querySelectorAll('[data-emiah-sale-modal-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-emiah-sale-modal-open');
        var modal = document.getElementById(id);
        if (!modal) return;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      });
    });

    scope.querySelectorAll('[data-emiah-sale-modal-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        var modal = closest(button, '[data-emiah-sale-modal]');
        if (!modal) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
      });
    });
  }

  function initSaleWheel(scope) {
    scope.querySelectorAll('[data-emiah-sale-spin]').forEach(function (wrap) {
      var wheel = wrap.querySelector('[data-emiah-sale-wheel]');
      var button = wrap.querySelector('[data-emiah-sale-spin-button]');
      var result = wrap.querySelector('[data-emiah-sale-spin-result]');
      var prizes = (wrap.getAttribute('data-prizes') || '').split('|').filter(Boolean);
      if (!wheel || !button || !prizes.length) return;

      var spinning = false;
      var turns = 0;
      button.addEventListener('click', function () {
        if (spinning) return;
        spinning = true;
        var index = Math.floor(Math.random() * prizes.length);
        turns += 1;
        var slice = 360 / prizes.length;
        var angle = turns * 1440 + (360 - index * slice - slice / 2);
        wheel.style.transform = 'rotate(' + angle + 'deg)';
        if (result) result.textContent = '';
        window.setTimeout(function () {
          spinning = false;
          if (result) result.textContent = prizes[index];
        }, 3300);
      });
    });
  }

  function initSaleOptions(scope) {
    scope.querySelectorAll('[data-emiah-sale-option-group]').forEach(function (group) {
      if (group.dataset.emiahSaleOptionsReady === 'true') return;
      group.dataset.emiahSaleOptionsReady = 'true';
      group.addEventListener('click', function (event) {
        var button = event.target.closest('[data-emiah-sale-option]');
        if (!button || !group.contains(button)) return;
        group.querySelectorAll('[data-emiah-sale-option]').forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });
      });
    });
  }

  function initSaleFeaturedVideos(scope) {
    scope.querySelectorAll('.emiah-sale-featured-card__media video').forEach(function (video) {
      if (video.dataset.emiahSaleFeaturedVideoReady === 'true') return;
      video.dataset.emiahSaleFeaturedVideoReady = 'true';
      video.muted = true;
      video.playsInline = true;

      function playWhenReady() {
        if (!video.paused) return;
        var playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(function () {});
        }
      }

      if (video.readyState >= 2) {
        playWhenReady();
      } else {
        video.addEventListener('canplay', playWhenReady, { once: true });
      }
    });
  }

  function init() {
    initSaleNav(document);
    initSaleModals(document);
    initSaleWheel(document);
    initSaleOptions(document);
    initSaleFeaturedVideos(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSaleNav(event.target);
    initSaleModals(event.target);
    initSaleWheel(event.target);
    initSaleOptions(event.target);
    initSaleFeaturedVideos(event.target);
  });
})();
